import { ReactNode, useEffect, useState } from "react";
import { MdOutlineKeyboardArrowDown, MdOutlineKeyboardArrowUp } from "react-icons/md";
import "./collapsible.scss";

export interface ICollapsibleProps {
  children?: ReactNode;
  title: string;
  fieldCount?: number;
  defaultOpen?: boolean;
  disabled?: boolean;
  onToggle?: (isOpen: boolean) => void;
  forceClose?: boolean;
}

const Collapsible = ({children, title, fieldCount, defaultOpen = false, onToggle, disabled = false, forceClose}: ICollapsibleProps) => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(!defaultOpen);

  const handleToggle = () => {
    if (disabled) {
      return;
    }
    
    const newCollapsedState = !isCollapsed;
    setIsCollapsed(newCollapsedState);
    onToggle && onToggle(!newCollapsedState);
  };

  useEffect(() => {
    if (forceClose) {
      setIsCollapsed(true);
      onToggle && onToggle(false);
    }
  }, [forceClose]);

  return (
    <div className={`collapsible ${disabled ? "collapsible-disabled" : ""}`}>
      <div 
        className={`collapsible-header ${disabled ? "collapsible-header-disabled" : ""}`} 
        onClick={handleToggle}
        style={{ cursor: disabled ? "not-allowed" : "pointer" }}
      >
        <div className="collapsible-title">
          <h4>{title}</h4>
        </div>
        <div className="collapsible-headerRight">
          {fieldCount !== undefined && (
            <span className="collapsible-badge">{fieldCount} fields</span>
          )}
          <div className="collapsible-icon">
            {isCollapsed ? <MdOutlineKeyboardArrowDown /> :
              <MdOutlineKeyboardArrowUp />
            }
          </div>
        </div>
      </div>
      <div className={`collapsible-content ${isCollapsed ? "collapsible-isCollapsed" : ""}`}>
          {children}
      </div>
    </div>
  );
}

export default Collapsible;